import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import { AutoComplete, Input, List } from "antd";
import { noDataImg, MyIcon, IMG_DEFAULT } from "../../common/baseConfig";
import { str } from "../../utils";
import { Link } from "react-router-dom";
export class Search extends Component {
  static propTypes = {
    common: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };
  state = {
    keyWord: "",//关键字
    keyAfterSub: "",//提交成功后拿到关键字
    curPage: 1,
  }
  componentDidMount() {
    const { search } = this.props.history.location;
    const keyWord = decodeURI(search.slice(search.indexOf("=") + 1, search.length));
    this.setState({ keyWord, keyAfterSub: keyWord }, () => {
      this.onLoadSearchData();
    })
  }
  onLoadSearchData() {
    if (this.state.keyWord.trim() === "") {
      return;
    }
    this.props.actions.fetchGetSearchData({
      PageSize: 8,
      PageIndex: this.state.curPage,
      PageStatus: 1,
      Name: this.state.keyWord,
    }).then(res => {
      if (res.SuccessResponse) {
        this.setState({
          keyAfterSub: this.state.keyWord,
        })
        if (this.state.keyAfterSub.trim() === "") {
          this.props.history.replace("/search");
        } else {
          this.props.history.replace(`/search?key=${encodeURI(this.state.keyAfterSub)}`)
        }
        //记录搜索记录
        let record = JSON.parse(localStorage.getItem("searchRecord")) || [];
        if (record.indexOf(this.state.keyWord) !== -1) {
          return;
        }
        if (record.length < 8) {
          record.unshift(this.state.keyWord);
        } else {
          record.pop();
          record.unshift(this.state.keyWord);
        }
        localStorage.setItem("searchRecord", JSON.stringify(record));
      }
    })
  }
  renderItem(item) {
    return (
      <Link key={item.ID} className="search-list-item" target="_blank" to={item.courseType === 0 ? `/course/detail/${item.ID}` : `/coursepack/detail/${item.ID}`}>
        <img src={item.CoverPath ? item.CoverPath + '?x-oss-process=image/resize,m_fixed,h_158,w_283' : IMG_DEFAULT} alt="" />
        {
          item.courseType === 1 &&
          <span className="pack-tag">课程包</span>
        }
        <h2>
          <span dangerouslySetInnerHTML={{ __html: str.wrapKeyWord(item.Name, this.state.keyAfterSub) }} />
          {item.courseType !== 1 && item.TeacherName && <span>- {item.TeacherName}</span>}
        </h2>
        <p>
          <span>
            {item.Price === 0 ? '免费' : '¥' + item.Price.toFixed(2)}{' '}
          </span>
          <span>
            <MyIcon type="iconrenshu" /> {item.BuyBase + item.BuyCount}
          </span>
        </p>
      </Link>
    )
  }
  render() {
    const dataSource = JSON.parse(localStorage.getItem("searchRecord")) || [];
    const { keyWord, curPage, keyAfterSub } = this.state;
    const { fetchGetSearchDataPending, fetchGetSearchDataSuccess, fetchGetSearchDataTotal } = this.props.common;
    let Data = fetchGetSearchDataSuccess || [];
    return (
      <div className="common-search">
        <div className="search-banner">
          <div className="search">
            <AutoComplete
              className="search_input"
              dropdownClassName="search_input_dropdown"
              dropdownMatchSelectWidth={false}
              dropdownStyle={{ width: 455 }}
              size="large"
              style={{ width: '100%' }}
              dataSource={dataSource}
              value={keyWord}
              onChange={(value) => {
                this.setState({
                  keyWord: value,
                })
              }}
              placeholder="请输入要搜索课程、课程包的名字"
            >
              <Input suffix={<div className='search_icon_wrap' onClick={() => {
                this.props.actions.resetSearchTotal();
                this.onLoadSearchData();
              }}>
                <div className='search_icon'></div>
              </div>} />
            </AutoComplete>
          </div>
        </div>
        <div className="search-list">
          <h1>
            {
              keyAfterSub.trim() !== "" && <p>共有{fetchGetSearchDataTotal}门包含<span>"{keyAfterSub}"</span>的课程</p>
            }
          </h1>
          {
            Data.length > 0 ? (
              <List
                itemLayout="horizontal"
                size="large"
                pagination={{
                  onChange: page => {
                    this.setState({
                      curPage: page,
                    }, () => {
                      this.onLoadSearchData();
                    })
                  },
                  current: curPage,
                  total: fetchGetSearchDataTotal,
                  pageSize: 8,
                }}
                loading={fetchGetSearchDataPending}
                dataSource={Data}
                renderItem={item => this.renderItem(item)}
              />
            ) : (
                <div className="noneData">
                  <img src={noDataImg} alt="" />
                  <p>无相关搜索记录</p>
                </div>
              )
          }
        </div>
      </div>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    common: state.common,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Search);



// WEBPACK FOOTER //
// ./src/features/common/Search.js